/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
  location_division_id: z.number(),
  ancestor_slot: z.number(),
  ancestor_division_name: z.string(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
  ancestor_slot: base.shape.ancestor_slot.optional(),
  ancestor_division_name: base.shape.ancestor_division_name.optional(),
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.number() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const LocationDivisionParentPathBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type LocationDivisionParentPathBase = z.infer<typeof base>;
export type LocationDivisionParentPathBasePutPayload = z.infer<typeof put>;
export type LocationDivisionParentPathBasePatchPayload = z.infer<typeof patch>;
export type LocationDivisionParentPathBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type LocationDivisionParentPathBaseCreateAttributes = z.infer<typeof create>;
export type LocationDivisionParentPathBaseUpdateAttributes = z.infer<typeof update>;
export type LocationDivisionParentPathBaseCacheAttributes = z.infer<typeof cache>;
export type LocationDivisionParentPathBaseCachesAttributes = z.infer<typeof caches>;